import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2612b3ec"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "rk" }
const _hoisted_2 = { class: "rk_info" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("机台/工位：")
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "material-title" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "title-prefix" }),
    /*#__PURE__*/_createElementVNode("span", null, "完工交接物料")
  ])
], -1))
const _hoisted_5 = { class: "material-content" }
const _hoisted_6 = {
  key: 0,
  class: "item-style"
}
const _hoisted_7 = { class: "item-title-style" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "green" }, "[合格品] ", -1))
const _hoisted_9 = { style: {"font-weight":"500"} }
const _hoisted_10 = { class: "item-content-style" }
const _hoisted_11 = { class: "subItem-style_top" }
const _hoisted_12 = { class: "subItem-first-style" }
const _hoisted_13 = { class: "subItem-second-style" }
const _hoisted_14 = { class: "subItem-style_bottom" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { key: 1 }
const _hoisted_17 = {
  key: 1,
  class: "item-style"
}
const _hoisted_18 = { class: "item-title-style" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "yellow" }, "[不良品] ", -1))
const _hoisted_20 = { style: {"font-weight":"500"} }
const _hoisted_21 = { class: "item-content-style" }
const _hoisted_22 = { class: "subItem-style_top" }
const _hoisted_23 = { class: "subItem-first-style" }
const _hoisted_24 = { class: "subItem-second-style" }
const _hoisted_25 = { class: "subItem-style_bottom" }
const _hoisted_26 = { key: 0 }
const _hoisted_27 = { key: 1 }
const _hoisted_28 = {
  key: 2,
  class: "item-style"
}
const _hoisted_29 = { class: "item-title-style" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "red" }, "[报废品] ", -1))
const _hoisted_31 = { style: {"font-weight":"500"} }
const _hoisted_32 = { class: "item-content-style" }
const _hoisted_33 = { class: "subItem-style_top" }
const _hoisted_34 = { class: "subItem-first-style" }
const _hoisted_35 = { class: "subItem-second-style" }
const _hoisted_36 = { class: "subItem-style_bottom" }
const _hoisted_37 = { key: 0 }
const _hoisted_38 = { key: 1 }
const _hoisted_39 = {
  key: 1,
  class: "notfound"
}
const _hoisted_40 = { class: "rk_sc" }
const _hoisted_41 = { class: "rk_sc_header" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "rk_sc_header_box" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "rk_sc_header_x" }),
  /*#__PURE__*/_createElementVNode("span", null, "本次余留次班生产")
], -1))
const _hoisted_43 = { key: 0 }
const _hoisted_44 = {
  key: 0,
  class: "rk_sc_content"
}
const _hoisted_45 = { class: "rk_sc_content_item_a" }
const _hoisted_46 = { class: "rk_sc_content_item_b" }
const _hoisted_47 = {
  key: 0,
  class: "rk_sc_content_item_hz"
}
const _hoisted_48 = { class: "rk_sc_content_item_hz_item_top" }
const _hoisted_49 = { class: "rk_sc_content_item_hz_item_bottom" }
const _hoisted_50 = { key: 0 }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "succ" }, "合格", -1))
const _hoisted_52 = { key: 1 }
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "yellow" }, "不良", -1))
const _hoisted_54 = { key: 2 }
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "warning" }, "报废", -1))
const _hoisted_56 = {
  key: 1,
  class: "rk_sc_content_item_hz"
}
const _hoisted_57 = {
  key: 1,
  class: "rk_sc_kong"
}
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "暂无数据", -1))
const _hoisted_59 = [
  _hoisted_58
]
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "rk_zw" }, null, -1))
const _hoisted_61 = { class: "rk_footer" }
const _hoisted_62 = /*#__PURE__*/_createTextVNode("完工入库")
const _hoisted_63 = [
  _hoisted_62
]

import { ref, onMounted, onBeforeUnmount } from 'vue'
    import { Toast } from 'vant'
    import { useRouter, useRoute } from "vue-router"
    import { finishedDetail, finished, finishedDetailNew, saveFinishRecord } from '@/apis/WorkOrderAPI'

    
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

    const route = useRoute()
    const router = useRouter()
    let info: any = ref([])

    const statistics = (arr: Array<any>): string => {
        let boxNum: number = 0
        let num: number = 0
        let dw: string = ''
        arr.forEach((element: any) => {
            if (element.reserveMaterialBeanList && element.reserveMaterialBeanList.length > 0) {
                element.reserveMaterialBeanList.forEach((element1: any, index: number) => {
                    if (index === 0) {
                        dw = element1.unitName
                    }
                    boxNum = boxNum + element1.boxNum
                    num = num + element1.num
                    console.log(boxNum, num, dw)
                })
            }
        })
        return boxNum + '盒' + ' | ' + num + dw
    }

    const wTotal = (hg: object, bl: object, bf: object): string => {
        let boxNum: number = 0
        let num: number = 0
        let dw: string = ''
        let arr: Array<any> = []
        if (hg) {
            arr.push(hg)
        }
        if (bl) {
            arr.push(bl)
        }
        if (bf) {
            arr.push(bf)
        }
        arr.forEach((element: any, index: number) => {
            if (index === 0) {
                dw = element.unitName
            }
            boxNum = boxNum + element.boxNum
            num = num + element.num
        })
        return boxNum + '盒' + ' | ' + num + dw
    }

    const total = (arr: Array<any>): string => {
        let dw: string = ''
        let boxNum: number = 0
        let sumNum: number = 0
        if (arr.length > 0) {
            arr.forEach((element: any, index: number) => {
                if (index === 0) {
                    dw = element.unitName
                }
                boxNum = boxNum + element.sumBox
                sumNum = sumNum + element.sumNum
            })
        }
        return boxNum + '盒' + ' | ' + sumNum + dw
    }

    // 完工入库提交
    const submit = () => {
        let deviceIds: any = route.query.ids
        finished({  // 提交入库
            deviceIds: deviceIds ? deviceIds : '',
            inIds: window.sessionStorage.getItem('ids') ? window.sessionStorage.getItem('ids') : ''
        }).then(res => {
            if (res.code === 200) {
                saveFinishRecord({  // 记录完工入库数据
                    originId: Number(res.data),
                    abstracts: JSON.stringify(info.value)
                }).then(result => {
                    if (result.code === 200) {
                        Toast.success({ message: '入库成功', duration: 2000, forbidClick: true })
                        setTimeout(() => {
                            // router.go(-1)
                            router.replace({ path: '/workbench' })
                        }, 2000)
                    }
                })
            }
        })
    }

    // 获取详情
    const finishedDetails = (ids: any) => {
        finishedDetailNew({
            deviceIds: route.query.ids,
            inIds: ids ? ids : ''
        }).then(res => {
            if (res.code === 200) {
                info.value = res.data
            }
        })
    }

    // 跳转预留班次
    const jump = () => {
        // if (window.sessionStorage.getItem('ids')) {
        //   router.push({ name: 'secondShift', query: { id: info.value.produceLocationIds, ids: window.sessionStorage.getItem('ids') } })
        // } else {
        router.push({ name: 'secondShift', query: { id: info.value.produceLocationIds.join(',') } })
        // }
    }

    onMounted(() => {

        finishedDetails(window.sessionStorage.getItem('ids'))

    })

    onBeforeUnmount(() => {

        if (window.sessionStorage.getItem('ids')) {
            window.sessionStorage.removeItem('ids')
        }

    })

return (_ctx: any,_cache: any) => {
  const _directive_preventReClick = _resolveDirective("preventReClick")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", null, "作业员：" + _toDisplayString(_unref(info).worker) + " / " + _toDisplayString(_unref(info).groupName), 1),
      _createElementVNode("span", null, [
        _hoisted_3,
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(info).deviceList, (item, i) => {
          return (_openBlock(), _createElementBlock("span", { key: i }, _toDisplayString(item.code) + " " + _toDisplayString(i === _unref(info).deviceList.length - 1 ? '' : '/ '), 1))
        }), 128))
      ])
    ]),
    _hoisted_4,
    _createElementVNode("div", _hoisted_5, [
      (_unref(info).qualifiedBeanList && _unref(info).qualifiedBeanList.length > 0 || _unref(info).rejectsBeanList && _unref(info).rejectsBeanList.length > 0 || _unref(info).scrapBeanList && _unref(info).scrapBeanList.length > 0)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            (_unref(info).qualifiedBeanList && _unref(info).qualifiedBeanList.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _hoisted_8,
                    _createElementVNode("span", _hoisted_9, _toDisplayString(total(_unref(info).qualifiedBeanList)), 1)
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(info).qualifiedBeanList, (item, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "subItem-style",
                        key: index
                      }, [
                        _createElementVNode("div", _hoisted_11, [
                          _createElementVNode("div", _hoisted_12, _toDisplayString(item.materialName) + " | " + _toDisplayString(item.materialCode), 1),
                          _createElementVNode("div", _hoisted_13, _toDisplayString(item.sumBox) + "盒 | " + _toDisplayString(item.sumNum) + _toDisplayString(item.unitName), 1)
                        ]),
                        _createElementVNode("div", _hoisted_14, [
                          (item.batch)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(item.procedureName ? item.procedureName : '-') + " | " + _toDisplayString(item.batch), 1))
                            : (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(item.procedureName), 1))
                        ])
                      ]))
                    }), 128))
                  ])
                ]))
              : _createCommentVNode("", true),
            (_unref(info).rejectsBeanList && _unref(info).rejectsBeanList.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                  _createElementVNode("div", _hoisted_18, [
                    _hoisted_19,
                    _createElementVNode("span", _hoisted_20, _toDisplayString(total(_unref(info).rejectsBeanList)), 1)
                  ]),
                  _createElementVNode("div", _hoisted_21, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(info).rejectsBeanList, (item, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "subItem-style",
                        key: index
                      }, [
                        _createElementVNode("div", _hoisted_22, [
                          _createElementVNode("div", _hoisted_23, _toDisplayString(item.materialName) + " | " + _toDisplayString(item.materialCode), 1),
                          _createElementVNode("div", _hoisted_24, _toDisplayString(item.sumBox) + "盒 | " + _toDisplayString(item.sumNum) + _toDisplayString(item.unitName), 1)
                        ]),
                        _createElementVNode("div", _hoisted_25, [
                          (item.batch)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_26, _toDisplayString(item.procedureName ? item.procedureName : '-') + " | " + _toDisplayString(item.batch), 1))
                            : (_openBlock(), _createElementBlock("span", _hoisted_27, _toDisplayString(item.procedureName), 1))
                        ])
                      ]))
                    }), 128))
                  ])
                ]))
              : _createCommentVNode("", true),
            (_unref(info).scrapBeanList && _unref(info).scrapBeanList.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                  _createElementVNode("div", _hoisted_29, [
                    _hoisted_30,
                    _createElementVNode("span", _hoisted_31, _toDisplayString(total(_unref(info).scrapBeanList)), 1)
                  ]),
                  _createElementVNode("div", _hoisted_32, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(info).scrapBeanList, (item, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "subItem-style",
                        key: index
                      }, [
                        _createElementVNode("div", _hoisted_33, [
                          _createElementVNode("div", _hoisted_34, _toDisplayString(item.materialName) + " | " + _toDisplayString(item.materialCode), 1),
                          _createElementVNode("div", _hoisted_35, _toDisplayString(item.sumBox) + "盒 | " + _toDisplayString(item.sumNum) + _toDisplayString(item.unitName), 1)
                        ]),
                        _createElementVNode("div", _hoisted_36, [
                          (item.batch)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_37, _toDisplayString(item.procedureName ? item.procedureName : '-') + " | " + _toDisplayString(item.batch), 1))
                            : (_openBlock(), _createElementBlock("span", _hoisted_38, _toDisplayString(item.procedureName), 1))
                        ])
                      ]))
                    }), 128))
                  ])
                ]))
              : _createCommentVNode("", true)
          ], 64))
        : (_openBlock(), _createElementBlock("div", _hoisted_39, "暂无数据"))
    ]),
    _createElementVNode("div", _hoisted_40, [
      _createElementVNode("div", _hoisted_41, [
        _hoisted_42,
        (_unref(info).finishedInBillBeanList && _unref(info).finishedInBillBeanList.length > 0)
          ? (_openBlock(), _createElementBlock("span", _hoisted_43, _toDisplayString(statistics(_unref(info).finishedInBillBeanList)), 1))
          : _createCommentVNode("", true)
      ]),
      (_unref(info).finishedInBillBeanList && _unref(info).finishedInBillBeanList.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(info).finishedInBillBeanList, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "rk_sc_content_item",
                key: index
              }, [
                _createElementVNode("div", _hoisted_45, _toDisplayString(item.code), 1),
                _createElementVNode("div", _hoisted_46, [
                  _createElementVNode("span", null, "接收人：" + _toDisplayString(item.userName) + " / " + _toDisplayString(item.departmentName), 1),
                  _createElementVNode("span", null, "时间：" + _toDisplayString(item.dealDate), 1)
                ]),
                (item.reserveMaterialBeanList.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.reserveMaterialBeanList, (items, i) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "rk_sc_content_item_hz_item",
                          key: i
                        }, [
                          _createElementVNode("div", _hoisted_48, [
                            _createElementVNode("span", null, _toDisplayString(items.materialName) + " | " + _toDisplayString(items.materialCode), 1),
                            _createElementVNode("span", null, _toDisplayString(items.boxNum) + "盒 | " + _toDisplayString(items.num) + _toDisplayString(items.unitName), 1)
                          ]),
                          _createElementVNode("div", _hoisted_49, [
                            (items.qualityType === 0)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_50, [
                                  _hoisted_51,
                                  _createTextVNode(" | " + _toDisplayString(items.procedureName) + _toDisplayString(items.batch ? ' | ' + items.batch : ''), 1)
                                ]))
                              : _createCommentVNode("", true),
                            (items.qualityType === 1)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_52, [
                                  _hoisted_53,
                                  _createTextVNode(" | " + _toDisplayString(items.procedureName) + _toDisplayString(items.batch ? ' | ' + items.batch : ''), 1)
                                ]))
                              : _createCommentVNode("", true),
                            (items.qualityType === 2)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_54, [
                                  _hoisted_55,
                                  _createTextVNode(" | " + _toDisplayString(items.procedureName) + _toDisplayString(items.batch ? ' | ' + items.batch : ''), 1)
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ]))
                      }), 128))
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_56, "当前入库单物料已使用"))
              ]))
            }), 128))
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_57, _hoisted_59))
    ]),
    _hoisted_60,
    _createElementVNode("div", _hoisted_61, [
      _createElementVNode("div", {
        class: "rk_footer_s",
        onClick: jump
      }, "余留次班"),
      _withDirectives((_openBlock(), _createElementBlock("button", {
        class: "rk_footer_u",
        onClick: submit
      }, _hoisted_63)), [
        [_directive_preventReClick]
      ])
    ])
  ]))
}
}

})